import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * ラベル持ちチェックボックスクラス
 *
 * @export CheckboxLabelComponent
 * @class CheckboxLabelComponent
 */
@Component({
  selector: 'app-checkbox-label',
  templateUrl: 'checkbox-label.component.html',
  styleUrls: ['checkbox-label.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CheckboxLabelComponent,
      multi: true,
    },
  ]
})
export class CheckboxLabelComponent implements OnInit, ControlValueAccessor {

  @ViewChild('checkbox', { static: true }) public checkbox: ElementRef;

  @Input() public subid: string = null;
  /** 強制活性モード判定 */
  @Input() forcedEnabledMode: string = null;
  /** 透明度 0で完全透明 1.0で完全不透明 */
  @Input() alpha: number = null;
  /** フォントファミリー */
  @Input() fontFamilyClass: string = null;
  /** ラベル */
  @Input() label: string = null;
  /** ID */
  @Input() id: string = null;
  /** 値 */
  @Input() value: string = null;
  /** レイアウト */
  @Input() layout: string = <string>'absolute';
  /** タブインデックス */
  @Input() tabindex: number = null;
  /** 選択判定 */
  @Input() selected: boolean = null;
  /** 活性判定 */
  @Input() disabled: boolean = <boolean>false;
  /** フォントサイズ */
  @Input() fontSize: number = null;

  /** クリック時 */
  @Output() clickOutput = new EventEmitter<any>();

  /**
   * Creates an instance of CheckboxLabelComponent.
   * @memberof CheckboxLabelComponent
   */
  constructor(
    public elementRef: ElementRef,
  ) { }

  onTouchedCallback: () => {};
  propagateChange = (_: any) => { };

  writeValue(value: any) {
    if ((value !== undefined) && (value !== null)) {
      this.selected = value;
    }
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  onChange(event) {
    this.selected = event.target.checked;
    this.propagateChange(event.target.checked);
  }

  /**
   * 初期処理
   *
   * @memberof CheckboxLabelComponent
   */
  ngOnInit(): void {
    this.checkbox.nativeElement.setAttribute('id', this.subid + '_sub');
    this.checkbox.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
  }

  /**
   * 選択判定取得
   *
   * @returns
   * @memberof CheckboxLabelComponent
   */
  public selectedValue() {
    return this.selected;
  }

}
